<!-- The name is the link, stretched over the card (shop-card__link::after), so the card reads to a screen reader as the
     shop's name and is one tap target on a phone. -->
<article class="shop-card" *ngIf="shop">
    <div class="shop-card__cover" aria-hidden="true">
        <img *ngIf="shop.Cover" [src]="shop.Cover" alt="" loading="lazy" decoding="async">
    </div>
    <div class="shop-card__body">
        <div class="shop-card__logo" aria-hidden="true">
            <img *ngIf="shop.Logo" [src]="shop.Logo" alt="" loading="lazy" decoding="async">
            <span *ngIf="!shop.Logo">{{ initial }}</span>
        </div>
        <div class="shop-card__name" role="heading" [attr.aria-level]="level">
            <a class="shop-card__link" [routerLink]="shop.Url">{{ shop.Name }}</a>
        </div>
        <div class="shop-card__verified" *ngIf="shop.Verified">
            <svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.6 5.9-4.2 4.6a.75.75 0 0 1-1.1 0L4.4 8.4a.75.75 0 1 1 1.1-1l1.4 1.5 3.6-4a.75.75 0 0 1 1.1 1z" />
            </svg>
            {{ 'shop-card-verified-seller' | t:'Verified seller' }}
        </div>
        <p class="shop-card__tagline" *ngIf="shop.Tagline">{{ shop.Tagline }}</p>
        <ul class="shop-card__stats" *ngIf="stats.length">
            <li *ngFor="let line of stats">{{ line.text }}</li>
        </ul>
    </div>
</article>
